export default __webpack_public_path__ + "static/media/result6.619c1a10.png";